import React, { useEffect } from 'react';
import { Button, Form, FormInstance, Radio } from 'antd';
import { useTranslation } from 'react-i18next';
import { useAppLocale } from '@/contexts/AppLocaleContext';

export interface ChangeLanguageFormValues {
  language: string;
}

interface Props {
  form: FormInstance<ChangeLanguageFormValues>;
  submitting: boolean;
  onSubmit: (values: ChangeLanguageFormValues) => void;
}

export const ChangeLanguage: React.FC<Props> = ({ form, submitting, onSubmit }) => {
  const { t } = useTranslation();
  const { currentLanguage } = useAppLocale();

  useEffect(() => {
    form.setFieldsValue({ language: currentLanguage });
  }, [form, currentLanguage]);

  return (
    <div className="flex flex-col">
      <Form
        form={form}
        layout="vertical"
        className="flex-1 overflow-auto px-3 pt-2"
        requiredMark={false}
        onFinish={onSubmit}
        initialValues={{ language: currentLanguage }}
      >
        <div className="text-[11px] text-919EAB uppercase mb-4 tracking-wide font-bold">
          {t('tai-khoan.language.select', 'LỰA CHỌN NGÔN NGỮ')}
        </div>

        <Form.Item
          name="language"
          rules={[{ required: true, message: t('tai-khoan.language.required', 'Vui lòng chọn ngôn ngữ') }]}
        >
          <Radio.Group className="w-full">
            <div className="flex flex-col gap-5">
              <label className="flex items-center justify-between cursor-pointer">
                <span className="text-[14px] font-medium text-637381">
                  {t('tai-khoan.language.vietnamese', 'Tiếng việt')}
                </span>
                <Radio value="vi" className="!text-[#1B252E] font-normal" />
              </label>

              <label className="flex items-center justify-between cursor-pointer">
                <span className="text-[14px] font-medium text-637381">
                  {t('tai-khoan.language.english', 'Tiếng Anh')}
                </span>
                <Radio value="en" className="!text-[#1B252E] font-normal" />
              </label>
            </div>
          </Radio.Group>
        </Form.Item>

        <Button
          size="large"
          type="primary"
          htmlType="submit"
          loading={submitting}
          className="!bg-[#1B252E] hover:opacity-80 border-none w-full mt-6 !font-bold !text-[14px]"
        >
          {t('bsc.btn.capnhat', 'Cập nhật')}
        </Button>
      </Form>

      {/* ===== Override ant radio inner color ===== */}
      <style>{`
        .ant-radio-wrapper .ant-radio-inner {
          color: var(--color-637381);
          width: 24px;
          height: 24px;
        }
        .ant-radio-wrapper .ant-radio-checked .ant-radio-inner::after {
          transform: scale(-0.725);
          background-color: var(--color-0A0A0A);
        }
        .ant-radio-wrapper .ant-radio-checked .ant-radio-inner {
          background-color: var(--color-white);
          border-color: var(--color-0A0A0A);
        }
      `}</style>
    </div>
  );
};
